module.exports = {
      id: "bullet-arrow-usage",
      viewBox: "0 0 22 20",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#bullet-arrow",
      toString: function () {
        return this.url;
      }
    }